'use client'

import FilterableContainer from '@/components/content/common/FilterableContainer'
import StackThumbnail from '@/components/content/stacks/root/StackThumbnail'
import { filterStacksByCategory } from '@/components/content/stacks/helpers'
import { PageContextProvider } from '@/components/content/common/PageContext'
import type { FeaturedSection } from '@/types/app'
import type { Stack, Category } from '@/payload-types'

type StackWithKeys = Pick<
  Stack,
  | 'id'
  | 'slug'
  | 'icon'
  | 'name'
  | 'type'
  | 'description'
  | 'summary'
  | 'notes'
  | 'stackApps'
  | 'stackFaqs'
  | 'updatedAt'
  | 'lastPublishedAt'
>

type StackCategoryWithKeys = Pick<Category, 'id' | 'name' | 'slug'>

type StackContainerProps = {
  stacksFeaturedTagSections: FeaturedSection[]
  stacks: StackWithKeys[]
  categories: StackCategoryWithKeys[]
}

export default function StackContainer({
  stacksFeaturedTagSections,
  stacks,
  categories,
}: StackContainerProps) {
  return (
    <PageContextProvider scrollOffset={145}>
      <FilterableContainer
        collection="stacks"
        categories={categories}
        items={stacks}
        filterItems={(items, cat) =>
          filterStacksByCategory(items as Stack[], cat) as StackWithKeys[]
        }
        featuredItems={stacksFeaturedTagSections}
        element={({ item, type }: { item: StackWithKeys; type?: string }) => (
          <StackThumbnail stack={item} type={type} />
        )}
        cols={2}
      />
    </PageContextProvider>
  )
}
